module.exports = __webpack_public_path__ + "img/VP-ProfiNew-User.13751c53.jpg";